/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationSidebarMenuAliases {
  AUTOCOMPLETE_MENU_MOBILE = 'autocomplete-menu-mobile',
  AVATAR_0 = 'avatar-0',
  BREADCRUMB_ACCREDITATION = 'breadcrumb-accreditation',
  DECK_MENU = 'deck-menu',
  FETCH_MENUS = 'fetch-menus',
  FETCH_MENUS_MOBILE = 'fetch-menus-mobile',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FORM_MENU_MOBILE = 'form-menu-mobile',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  FRAGMENT_2 = 'fragment-2',
  FRAGMENT_BANK_DATA = 'fragment-bank-data',
  FRAGMENT_BEDS = 'fragment-beds',
  FRAGMENT_CLINICAL_STAFF = 'fragment-clinical-staff',
  FRAGMENT_COMPLEMENTARY_DATA = 'fragment-complementary-data',
  FRAGMENT_CONCLUSION = 'fragment-conclusion',
  FRAGMENT_DOCUMENTS = 'fragment-documents',
  FRAGMENT_PACKAGES = 'fragment-packages',
  FRAGMENT_PROFESSIONALS = 'fragment-professionals',
  FRAGMENT_QUALIFICATIONS = 'fragment-qualifications',
  FRAGMENT_SERVICES = 'fragment-services',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_ACCREDITATION = 'layout-accreditation',
  MAPPER_0 = 'mapper-0',
  PANEL_1 = 'panel-1',
  PANEL_ACCREDITATION = 'panel-accreditation',
  PANEL_ACCREDITATION_BANK_DATA = 'panel-accreditation-bank-data',
  PANEL_ACCREDITATION_SPECIALTY = 'panel-accreditation-specialty',
  PANEL_ACCREDITATION_UPDATE = 'panel-accreditation-update',
  PANEL_BEDS_AND_EQUIPMENTS = 'panel-beds-and-equipments',
  PANEL_CLINICAL_STAFF = 'panel-clinical-staff',
  PANEL_CNES = 'panel-cnes',
  PANEL_COMPLEMENTARY_DATA = 'panel-complementary-data',
  PANEL_CONCLUSION = 'panel-conclusion',
  PANEL_DOCUMENTS = 'panel-documents',
  PANEL_ESTABLISHMENT = 'panel-establishment',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_PACKAGES = 'panel-packages',
  PANEL_PROFESSIONALS = 'panel-professionals',
  PANEL_QUALIFICATIONS = 'panel-qualifications',
  PANEL_REFUSAL_TOAST = 'panel-refusal-toast',
  PANEL_SERVICES_AND_MATERIALS = 'panel-services-and-materials',
  PANEL_SIDEBAR = 'panel-sidebar',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
  TOAST_NOTIFICATION_REFUSAL = 'toast-notification-refusal',
}
export { AccreditationSidebarMenuAliases };
